import { IconContainerProps, Rating, styled } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";

import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';

/**
 * Icons
 */

const customIcons: {
  [index: string]: {
    textColor: string;
    icon: React.ReactElement<unknown>;
    label: string;
  };
} = {
  1: {
    textColor: 'text-red-500',
    icon: <SentimentVeryDissatisfiedIcon className="text-red-500" />,
    label: 'Não atendeu',
  },
  2: {
    textColor: 'text-yellow-500',
    icon: <SentimentSatisfiedIcon className="text-yellow-500" />,
    label: 'Atendeu parcialmente',
  },
  3: {
    textColor: 'text-green-600',
    icon: <SentimentVerySatisfiedIcon className="text-green-600" />,
    label: 'Atendeu plenamente',
  },
};

function IconContainer(props: IconContainerProps) {
  const { value, ...other } = props;
  const isSelected = other.className?.includes('MuiRating-iconFilled');
  return (
    <span {...other}>
      <div className="flex flex-col items-center">
        <span className="flex">
          {customIcons[value].icon}
        </span>
        <span className={`${isSelected ? customIcons[value].textColor : ''} text-xs`}>
          {typeof value === 'number' && value}
        </span>
      </div >
    </span >
  );
}

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
}));

/**
 * GenerateAvaliacaoFornecedorCadastroColumnDefinition
 */

type Props = {
  onNotaChange: (idCriterioAvaliacaoFornecedor: number, nota: number | null) => void;
};

export const GenerateAvaliacaoFornecedorCadastroColumnDefinition = ({
  onNotaChange,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Item",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="py-1">{value}</div>
        );
      }
    },
    {
      field: "nota",
      filterable: false,
      headerName: "Selecione a Nota",
      width: 150,
      sortable: false,
      align: 'center',
      valueGetter: (_, rows) => {
        return [rows['idCriterioAvaliacaoFornecedor'] as number, rows['nota'] as number];
      },
      renderCell: ({ value: [idCriterioAvaliacaoFornecedor, nota] }) => {
        return (
          <div className="flex flex-col justify-center items-center py-2">
            <StyledRating
              className="w-full h-full"
              getLabelText={(value: number) => customIcons[value].label}
              highlightSelectedOnly={true}
              value={nota}
              max={3}
              onChange={(_, newNota) => {
                onNotaChange(idCriterioAvaliacaoFornecedor, newNota);
              }}
              slotProps={{
                root: {
                  className: "flex flex-row justify-center items-center gap-2",
                },
                icon: {
                  component: IconContainer,
                }
              }}
            />
          </div>
        );
      },
    },
  ];
}
